    <div class="dx-card wide-card">
        <h4 class="content-block ap-green">ASU Manufacturer by Country</h4>
        <div class="content-block">
            <dx-responsive-box labelLocation="top" singleColumnScreen="xs sm md">
                <dxi-row [ratio]="1"></dxi-row>
                <dxi-col [ratio]="1"></dxi-col>
                <dxi-col [ratio]="1"></dxi-col>
                <dxi-col [ratio]="1"></dxi-col>
                <dxi-col [ratio]="1"></dxi-col>
                <dxi-col [ratio]=".5"></dxi-col>
                <dxi-item>
                    <dxi-location [row]="0" [col]="0"></dxi-location>
                    <div class="dx-field">
                        <div class="dx-field-label"><span class="error">*</span> Country</div>
                        <div class="dx-field-value">
                            <dx-select-box #country (onValueChanged)="onCountryChanged($event)" [showClearButton]="true"
                                [searchEnabled]="true" [(value)]="selectedCountry" [items]="countryDataSource">
                                <dx-validator>
                                    <dxi-validation-rule type="required" message="Country is required">
                                    </dxi-validation-rule>
                                </dx-validator>
                            </dx-select-box>
                        </div>
                    </div>
                </dxi-item>
                <dxi-item>
                    <dxi-location [row]="0" [col]="1"></dxi-location>
                    <div class="dx-field">
                        <div class="dx-field-label"><span class="error">*</span> Manufacturer</div>
                        <div class="dx-field-value">                           
                            <dx-drop-down-box class="maxwidth" #manufacturers [(value)]="selectedManufacturers"
                            placeholder="Select a value..." [showClearButton]="true"
                            [dataSource]="filteredManufacturerDataSource" valueExpr="manufacturer" displayExpr="manufacturer"
                            >
                            <div *dxTemplate="let data of 'content'">
                                <dx-list #manufacturerslist [dataSource]="filteredManufacturerDataSource" [height]="300"
                                    [selectionMode]="'all'" [selectAllMode]="'allPages'"
                                    [showSelectionControls]="true" [searchEnabled]="true"
                                    searchExpr="manufacturer" searchMode="contains" keyExpr="manufacturer"
                                    displayExpr="manufacturer" [selectedItemKeys]="selectedManufacturers"
                                    (onSelectionChanged)="onManufacturersListSelectionChanged($event)"
                                    scrollingEnabled="true">
                                </dx-list>
                            </div>
                            <dx-validator>
                                <dxi-validation-rule type="required"
                                    message="Please select atleast one Manufacturer.">
                                </dxi-validation-rule>
                            </dx-validator>
                        </dx-drop-down-box>
                        </div>
                    </div>

                </dxi-item>
                <dxi-item>
                    <dxi-location [row]="0" [col]="2"></dxi-location>
                    <div class="dx-field">
                        <div class="dx-field-label"><span class="error">*</span> Gas</div>
                        <div class="dx-field-value">
                            <dx-tag-box #gas [items]="gasDataSource" [maxFilterQueryLength]="5000" [multiline]="false"
                                [(value)]="selectedGas" [showSelectionControls]="true">
                                <dx-validator>
                                    <dxi-validation-rule type="required" message="Gas is required">
                                    </dxi-validation-rule>
                                </dx-validator>
                            </dx-tag-box>
                        </div>
                    </div>

                </dxi-item>

                <dxi-item>
                    <dxi-location [row]="0" [col]="4"></dxi-location>
                    <div class="dx-field">
                        <dx-button class="ap-blue-btn" type="default" (onClick)="populateData()" text="View Reports">
                        </dx-button>
                    </div>

                </dxi-item>
            </dx-responsive-box>
            <hr />
        </div>
        <div class="content-block" id="contentDiv">
            <h4>ASUs in {{selectedCountryResult}} Aggregated by Site & Manufacturer</h4>
            <div id="map" style="float: left;margin-right: 15px;">
            </div>
            <div id="techProviderLegend">
                <b>Color = Manufacturer</b>
                <hr />
            </div>
            <div id="sizeLegendN2" class="sizeLegend">
                <b>Size = Nitrogen</b>
                <hr />
            </div>
            <div id="sizeLegendO2" class="sizeLegend">
                <b>Size = Oxygen</b>
                <hr />
            </div>
        
        <div id="dataGridDiv" style="float: right;padding-top:2%">
            <h4>ASU Facilities by Train and Industrial Gas</h4>
            <dx-data-grid #ASUFacilitiesGrid id="ASUFacilitiesGrid"
                [dataSource]="filteredAsuManufacturerDataArray" [showRowLines]="true" [showColumnLines]="true"
                [showBorders]="true" [allowColumnResizing]="true" [rowAlternationEnabled]="true">
                <dxo-export [enabled]="true"></dxo-export>
                <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
                <dxo-toolbar>
                    <dxi-item name="groupPanel"></dxi-item>
                    <dxi-item location="after">
                        <dx-button icon="exportxlsx" stylingMode="contained" type="default" text="Export to Excel"
                            (onClick)="exportExcel($event)">
                        </dx-button>
                    </dxi-item>
                </dxo-toolbar>
                <dxi-column dataField="stateProvince" caption="State/Province"></dxi-column>
                <dxi-column dataField="siteId" [visible]="false" caption="Site Id" [width]="120"></dxi-column>
                <dxi-column dataField="city"></dxi-column>
                <dxi-column dataField="manufacturer"></dxi-column>
                <dxi-column dataField="owner"></dxi-column>
                <dxi-column dataField="customer"></dxi-column>
                <dxi-column dataField="businessModel"></dxi-column>
                <dxi-column dataField="gas" caption="Material"></dxi-column>
                <dxi-column dataField="gaseousMTPD" caption="Gas(MTPD)"></dxi-column>
                <dxi-column dataField="liqMTPD" caption="Liquid(MTPD) "></dxi-column>
                <dxi-column dataField="totIGMTPD" caption="Total(MTPD)"></dxi-column>
                <dxi-column dataField="productionFacilityId" caption="Facility ID"></dxi-column>
            </dx-data-grid>
        </div>
    </div>
        <dx-load-panel #dxLoadPanel shadingColor="rgba(0,0,0,0.4)" [visible]="isLoadPanelVisible" [showPane]="true"
            [shading]="false" [closeOnOutsideClick]="false">
        </dx-load-panel>
    </div>